import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import EformApiClient from '../../api/EformsApi'
import LoaderOverlay from '../../components/_common/LoaderOverlay'
import ErrorScreen from '../../containers/ErrorScreen'
import { initValueObjects } from '../../utils/utils'
import Invoice from './Invoice'

const InvoiceWrap = () => {

  const { submissionID } = useParams() as any
  const [values, setValues] = useState<any>(null)
  const [subs, setSubs] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState('')

  useEffect(() => {
    const fetch = async () => {
      setLoading(true)
      try {

        const submission: any = await EformApiClient.submission.getSubmission(submissionID)
        const specData: any = await EformApiClient.formSchema.getFormSchemaVersionByIri(submission.formSchemaVersion)
        submission.widget = specData.layout.widget
        setSubs(submission)

        const submissionValues = initValueObjects(
          submission.data,
          specData.schema.properties
        )
        setValues(submissionValues)

      } catch (e) {
        console.error('Nepodařilo se načíst data', e)
        setErr('Nepodařilo se načíst data')
      } finally {
        setLoading(false)
      }

    }
    fetch()
  }, [submissionID])

  const invoiceFromValues = (values: any) => {
    if (values?.platba?.variabilniSymboly) {
      return Object.values(values.platba.variabilniSymboly).map((platbaDataVS: any) => ({
        varSymbol: platbaDataVS.variabilniSymbol,
        regCislo: platbaDataVS.regCislo
      }))
    }
    if (values?.platba?.variabilniSymbol) {
      return [{ varSymbol: values.platba?.variabilniSymbol }]
    }

    return []
  }

  const variabilniSymboly: any[] = invoiceFromValues(values)

  return (
    <LoaderOverlay
      isLoading={loading}
      fixed
      overflow={false}
      className="page-all"
    >

      {err ?
        <ErrorScreen errorText={err}/>
        :
        variabilniSymboly.map(({ varSymbol, regCislo }: any, index: number) =>
          <Invoice key={index} values={values} submission={subs} varSymbol={varSymbol} regCislo={regCislo}/>
        )
      }
    </LoaderOverlay>
  )
}

export default InvoiceWrap
